function decrementValueOnItem(item, step=1) {
  if (parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) > step) {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = (
      parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) - step
    ).toString();
  }
}

function incrementValueOnItem(item, step=1) {
  item.parentNode.querySelectorAll("input[type=text]")[0].value = (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) + step
  ).toString();
}

function updateCartCounter(quantity) {
  const cartCounter = document.getElementById('cart-counter');
  if (quantity > 0) {
    cartCounter.classList.remove("hidden");
    cartCounter.classList.add("flex");
  } else {
    cartCounter.classList.add("hidden");
  }
  cartCounter.innerHTML = quantity;
}


function appendAddOpenCartToAddToCartBtns(arr) {
  for (let i=0;i<arr.length;i++) {
    element = arr[i]
    let varId = element.dataset.id || element.dataset.variantId

    element.addEventListener("click", function(e) {
      handleAddToCart(1, varId)
    })
  }
} 

window.onload = function() {
  const addcartbtns = document.querySelectorAll('[data-text-added-cart]')
  
  if (addcartbtns) {
    appendAddOpenCartToAddToCartBtns(addcartbtns);
  }
};

// Function to handle cart hash detection and opening
function handleCartHash() {
  if (window.location.hash === "#cart") {
    // Check if CBI cart is enabled, otherwise use Bloom
    if (window.CBI_CART_PANEL_ENABLED !== false) {
      // Use the existing showCBICart function from cbi_cart.js
      if (typeof showCBICart === "function") {
        showCBICart();
      }
    } else {
      // Fall back to Bloom cart if CBI cart is disabled
      if (window.bloom && typeof bloom.showCart === "function") {
        bloom.showCart();
      }
    }
  }
}

// Check for cart hash on page load
document.addEventListener("DOMContentLoaded", function () {
  handleCartHash();
});

// Listen for hash changes (when user navigates to /#cart)
window.addEventListener("hashchange", function () {
  handleCartHash();
});